import endPoints from 'widget/api/endPoints';
import { API } from 'widget/helpers/axios';

export const getFlipperFeatures = async websiteToken => {
  const urlData = endPoints.getFlipperFeatures(websiteToken);
  return API.get(urlData.url, { params: urlData.params });
};
